import React from 'react';

// Modern (jjfv2) header / hero / footer
import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import BlogSidebar from './BlogSidebar';
import { Helmet } from 'react-helmet';

// CSS imoports
import '../AboutUsPage/aboutV2.css';
import './blogs.css';

// Image imports
import Blog1Img from "./../../images/blogs/seed_of_change.webp";

export default function SeedsofChange() {
    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />

                {/* Basic Meta Tags */}
                <title>Seeds of Change: How Young Minds in Varanasi Are Growing a Greener Tomorrow | JJF India</title>
                <meta name="description" content="JJFIndia partners with Shandilya Public School, Varanasi, for an environmental awareness program, distributing 200+ seeds to the next generation of planet protectors." />
                <meta name="keywords" content="JJFIndia, Prakriti ki Pathshala, Shandilya Public School Varanasi, environmental awareness program, tree plantation drive 2025, Jainam Jivika Foundation, seed distribution initiative" />
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://jjfindia.com/our-bulletin/seeds-of-change" />

                {/* Open Graph */}
                <meta property="og:title" content="Seeds of Change: How Young Minds in Varanasi Are Growing a Greener Tomorrow | JJF India" />
                <meta property="og:description" content="JJFIndia partners with Shandilya Public School, Varanasi, for an environmental awareness program, distributing 200+ seeds to the next generation of planet protectors." />
                <meta property="og:url" content="https://jjfindia.com/our-bulletin/seeds-of-change" />

                {/* Twitter Cards */}
                {/* <meta name="twitter:card" content={metadata.twitter?.card} /> */}
                <meta name="twitter:title" content="Seeds of Change: How Young Minds in Varanasi Are Growing a Greener Tomorrow | JJF India" />
                <meta name="twitter:description" content="JJFIndia partners with Shandilya Public School, Varanasi, for an environmental awareness program, distributing 200+ seeds to the next generation of planet protectors." />
            </Helmet>

            <div className="jjfv2">
                <HeaderV2 />
                <AboutHero
                    eyebrow="Our Bulletin"
                    title="Blogs"
                    crumbs={[{ label: 'Home', to: '/' }, { label: 'Blogs' }]}
                />
            </div>
            <main className="page_content">
                    <div style={{paddingBottom: "60px", paddingTop: "60px"}} className="container">
                        <div className='single-blog-container' >
                            <div className="blog-article">
                                <h1>Seeds of Change: How Young Minds in Varanasi Are Growing a Greener Tomorrow</h1>
                                <div>
                                    <img src={Blog1Img} alt='blog' />
                                </div>
                                <div style={{display: "flex", alignContent: "flex-end", width: "100%"}}>
                                    <span style={{ width:"100%", textAlign: "right", paddingTop: "16px", paddingBottom: "16px" }}>10 November, 2023</span>
                                </div>
                                <div>
                                    <p>It’s often said that small steps lead to big changes - and at Shandilya Public School, Varanasi, that belief took root, quite literally.</p>
                                    <p>On <strong>10th September 2025,</strong> the school, in collaboration with Jainam Jivika Foundation, hosted an environmental awareness program (Prakriti ki Pathshala) that brought together <strong>190 enthusiastic students</strong> from Classes 6 to 10. Guided by Harshvardhan (Outreach Intern) and Saurabh (Outreach & Partnerships Lead), the session inspired children to think deeply about their role in protecting the planet.</p>
                                    <p>The event’s highlight was a vibrant tree plantation drive on campus, symbolising unity and collective responsibility. Each sapling planted carried hope for a cleaner, greener future.</p>
                                    <p>More than <strong>200 seed packets</strong> were distributed, encouraging students to continue their green journey beyond the classroom -  turning learning into living.</p>
                                    <p>As the school’s Principal beautifully said:</p>
                                    <p><q><i>The tree plantation and seed distribution are just the beginning of their journey toward becoming responsible, eco-conscious citizens.</i></q></p>
                                    <p>When education meets action, seeds of change truly begin to grow. Through initiatives like Prakriti ki Pathshala, young minds are not only learning about the environment -they are becoming its future guardians.</p>
                                </div>
                            </div>
                            <div>
                                <BlogSidebar />
                            </div>
                        </div>                    
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
        </>
    );
}